export const onResponseError = async (error) => {
    throw error;
};

export const interceptResponse = async (response) => {
    return response;
};
